/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/extensions,
  import/no-extraneous-dependencies,
  max-len,
*/
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import ContentButton from 'signer/components/common/content-button';
import icon from 'signer/assets/Reassign_signer_icon.svg';
import Footer from 'hellosign/components/app/footer';
import Header from 'common/components/headers/external/google-marketing/index.jsx';
import { messages, postMessage } from 'common/utils/messages';
import './index.scss';

const hsMessages = defineMessages({
  parentUrlPropertyNotFound: {
    id: '',
    description: 'The signature request being delegated.  When embedded, we must have a `parentUrl` property in order to properly close the iframe',
    defaultMessage: 'When the signer page is embedded a parentUrl property must be present in the "embeddedData" on the signature request',
  },
});

/**
 * Displays a message to the user once the signer delegation action has been
 * completed.
 */
export class SignatureRequestDelegateComplete extends React.Component {

    static defaultProps = {
      headerProps: {},
      onXwmSend: () => {},
    };

    static propTypes = {

      /**
         * An object of props to be passed to the header component
         */
      headerProps: PropTypes.object,


      /**
         * Indicates whether the component is being rendered in the embedded context
         */
      isEmbedded: PropTypes.bool,

      /**
         * The function to be called for sending cross-window messaging.  This will
         * be the global client-side library function, `HelloSign.XWM.send`.
         * Passing this in as a prop makes it easier to test.
         */
      onXwmSend: PropTypes.func,

      intl: PropTypes.object,

      /**
         * The signature request being delegated.  When embedded, we must have a
         * `parentUrl` property in order to properly close the iframe.
         */
      signatureRequest(props) {
        if (props.isEmbedded && !(props.signatureRequest && props.signatureRequest.embeddedData.parentUrl)) {
          return new Error(this.props.intl.formatMessage(hsMessages.parentUrlPropertyNotFound));
        }
      },
    };


    constructor(props) {
      super(props);

      this.handleIframeClose = this.handleIframeClose.bind(this);
    }

    handleIframeClose() {
      const { signatureRequest, onXwmSend } = this.props;
      const parentUrl = signatureRequest.embeddedData.parentUrl;

      onXwmSend('user-done', parentUrl);
      postMessage({
        type: messages.USER_FINISH_REQUEST,
      }, parentUrl);
    }

    render() {
      const { isEmbedded, headerProps, signatureRequest } = this.props;

      return <div className='m-signature-request-delegate-complete'>
        {!isEmbedded && <Header {...headerProps} data-test-ref='header' />}

        <div className='main'>
          <img src={icon} />
          <h1>
            <FormattedMessage
              id="signer.delegate.complete.documentDelegated"
              description="text in signer flow, informing singer that the signature request has been reassigned to new signer"
              defaultMessage="This document has now been reassigned to {newSignerName}"
              values={{ newSignerName: signatureRequest.newSignerName }} />
          </h1>
          <h2>
            <FormattedMessage
              id="signer.delegate.complete.emailConfirmation"
              description="text in signer flow, informing signer that confirmation email will shortly arrive about reassigning the signer"
              defaultMessage="You'll receive a confirmation email shortly." />
          </h2>

          {isEmbedded && <ContentButton
            className='whitelabel-secondary-button'
            onClick={this.handleIframeClose}
            data-test-ref='iframe-close-btn'
          >
            <FormattedMessage
              id="common.closeButton.labelText"
              description="button text of iFrame , clicking will close iFrame"
              defaultMessage="Close" />
          </ContentButton>}
        </div>

        {!isEmbedded && (
          <Footer
            siteCode='S'
            data-test-ref='footer'
            termsURL={''}
            privacyURL={''}
            className='app-footer--signer' />
        )}
      </div>;
    }
}


export default injectIntl(SignatureRequestDelegateComplete);
